<template>
  <b-form @submit.prevent="submitForm" ref="form" :validated="validated" v-if="validId" novalidate>
    <fieldset v-if="!complete">
      <SignupLegend title="Create your aio* account"/>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">First name</label>
        <div class="col-sm-9">
          <input type="text" class="form-control" v-model="user.firstName" required>
          <div class="invalid-feedback">First name is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Last name</label>
        <div class="col-sm-9">
          <input type="text" class="form-control" v-model="user.lastName" required>
          <div class="invalid-feedback">Last name is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-3">
          <label class="col-form-label">Date of birth</label>
          <span id="dobInfo"><span class="info popup fas fa-info-circle"></span>
            <b-popover target="dobInfo" placement="bottom" triggers="hover focus">
              When you receive your card you need to activate it. Card services use your date of birth as one way to keep the activation secure.
            </b-popover>
          </span>
        </div>
        <div class="col-sm-9">
          <BaseSelectDate v-model="user.dateOfBirth"/>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Password</label>
        <div class="col-sm-9">
          <input type="password" class="form-control" minlength="9" v-model="user.password" required>
          <div class="invalid-feedback">Password with at least 9 characters is required.</div>
        </div>
      </div>
      <div class="form-check form-group">
        <input class="form-check-input" type="checkbox" id="terms-conditions" required>
        <label class="form-check-label" for="terms-conditions">I have read and accept the <a
                href="https://getaio.co.uk/privacy/" target="_blank">Privacy policy</a> and <a
                href="https://getaio.co.uk/terms-conditions/" target="_blank">Terms and Conditions</a> of aio*</label>
        <div class="invalid-feedback">Confirmation is required.</div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <button type="submit" class="btn btn-primary float-right">
            <span class="fas fa-lock"></span> Create account
          </button>
        </div>
      </div>
    </fieldset>
    <SignupFieldsetComplete v-else/>
  </b-form>
</template>

<script>
  import BaseSelectDate from '@/components/BaseSelectDate'
  import api from '@/utils/api'
  import Person from '@/utils/Person'
  import SignupFieldsetComplete from '@/components/SignupFieldsetComplete'
  import SignupLegend from '@/components/SignupLegend'

  export default {
    components: {
      BaseSelectDate,
      SignupFieldsetComplete,
      SignupLegend
    },
    data () {
      return {
        complete: false,
        user: new Person(),
        validated: false,
        validId: false
      }
    },
    methods: {
      async submitForm () {
        this.validated = true
        if (this.$refs.form.checkValidity()) {
          this.user.dob = Person.getDobString(this.user)
          await api.postUserRegistration(this.user)
          this.complete = true
        }
      }
    },
    async mounted () {
      this.$emit('set-title', 'Registration')
      this.user.uniqueId = Object.keys(this.$route.query)[0]
      this.user.gender = 'unknown'
      await api.checkUserIdForUserRegistration(this.user.uniqueId)
      this.validId = true
    }
  }
</script>

<style lang="scss" scoped>
</style>
